import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { create_company_hiring_manager_action, get_loggedin_user_meta_data_action, logout_user_action, update_user_timezone_action } from "../../../redux/_actions";
import { user_token } from "../../../_helpers/tokensStored";
import { validateUrl } from "../../../_helpers/validators";
import { formSchema } from "./schema";

function useHiringManagerOnboard() {
  const user = user_token;
  const [loading, setloading] = useState(false);
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { companyData, createCompanyError } = useSelector(
    (state) => state.create_company_hiring_manager_reducer
  );

  React.useEffect(() => {
    setformData({
      industry: "",
      name: "",
      size: "",
      url: "",
    });
  }, []);

  const onNextClick = async () => {
    if (
      user?.user.user_meta_info &&
      user?.user.user_meta_info.company !== null
    ) {
      navigate("/hiring-manager-onboard-success");
    } else {
      setloading(true);
      setFormInputsError({});
      if (validateForm()) {
        const res = await dispatch(
          create_company_hiring_manager_action(formData)
        );
        checkNavigate(res);
      }

      setloading(false);
    }
  };
  const onInputChange = (value, key) => {
    let data = formData;
    data[key] = value;
    setformData(data);
  };

  //navigate to screens
  const checkNavigate = (loginData) => {
    // success
    if (loginData && loginData.data && loginData.data !== null) {
      const user = JSON.parse(localStorage.getItem("jigsawUser"));
      user.user.user_meta_info.company = loginData?.data.company;
      user.user.user_meta_info.company_details =
        loginData?.data.company_details;
      localStorage.setItem("jigsawUser", JSON.stringify(user));
      navigate("/hiring-manager-onboard-success");
    } else {
      let form_errors = {
        ...formInputsError,
        formSubmitError:
          createCompanyError && createCompanyError !== ""
            ? createCompanyError && createCompanyError
            : "Unable to create company.",
      };
      setFormInputsError(form_errors);
    }
  };

  const onSignOut = async () => {
    const user_token = await localStorage.getItem('jigsawUser') && JSON.parse(localStorage.getItem('jigsawUser'))
    const refreshToken = user_token?.refresh_token
    await dispatch(logout_user_action({refresh: refreshToken}))
    window.location.reload()
  }

  //validate form
  const validateForm = () => {
    let form_errors = {};

    //validate name
    if (formData.name.length === 0) {
      form_errors = {
        name: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }

    //validate url
    if (formData.url.length === 0) {
      form_errors = {
        url: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (!validateUrl(formData.url)) {
      form_errors = {
        url: "Enter valid url",
      };
      setFormInputsError(form_errors);
      return false;
    }
    //validate size
    if (formData.size.length === 0) {
      form_errors = {
        size: "Field cannot be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.industry.length === 0) {
      form_errors = {
        industry: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }

    return true;
  };
  const onTimeZoneChange = async (e) => {
    let value = e.target.value;
    let key = e.target.name;
    let data = {};
    data[key] = value;
    await dispatch(update_user_timezone_action(data));
    await dispatch(get_loggedin_user_meta_data_action());
  };

  return {
    loading,
    formInputsError,
    onNextClick,
    onInputChange,
    onSignOut,
    onTimeZoneChange
  };
}

export default useHiringManagerOnboard;
